import { useSearchParams } from "react-router";

const errorMessages: Record<string, string> = {
  access_denied: "You denied access to your Threads account.",
  missing_params: "Invalid OAuth callback. Please try again.",
  invalid_state: "Security check failed. Please try again.",
  auth_failed: "Authentication failed. Please try again.",
};

export function LoginPage() {
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-4">
      <div className="w-full max-w-sm text-center">
        <h1 className="text-2xl font-bold tracking-tight">Yarnalytics</h1>
        <p className="mt-2 text-sm text-neutral-500">
          Sign in with your Threads account to continue.
        </p>

        {error && (
          <div className="mt-4 rounded-lg border border-danger/20 bg-red-50 p-3 text-sm text-danger">
            {errorMessages[error] || "Something went wrong. Please try again."}
          </div>
        )}

        <a
          href="/api/auth/login"
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-lg bg-black px-4 py-3 text-sm font-medium text-white hover:bg-neutral-800 transition-colors"
        >
          Sign in with Threads
        </a>

        <a
          href="/"
          className="mt-4 inline-block text-sm text-neutral-400 hover:text-black transition-colors"
        >
          Back to home
        </a>
      </div>
    </div>
  );
}
